import React from "react";
import { saveAs } from 'file-saver';
import { toBlob } from 'html-to-image';
import { useSelector } from 'react-redux'
import CreativeNameDisplay from "../shared/CreativeNameDisplay"
function FramePostPreview({ preview }) {
  const componentId = useSelector(state => state.Head.component_id)

  const handleDownloadPreview = () => {
    const previewElement = document.querySelector('.download-preview');
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.name}.png`);
    });
  };
  return (
    <>
      <div className="flex mb-5">

        {componentId === 6 ? <div className="justify-end">
          <sl-icon-button
            library="lucide"
            name="download"
            onClick={handleDownloadPreview}
          ></sl-icon-button>
        </div> : null}
      </div>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          <div className="preview-full-image">
            {preview.img_urls && <img src={preview.img_urls} alt="" className={`w-full ${preview.button_enabled ? 'h-[95%] mb-1' : 'h-full'}`} />}
            
          </div>
        </div>
      </div>
    </>
  );
}

export default FramePostPreview;
